import {hints} from './Hints.slices'

export const addHint = hints.actions.add
export const removeHint = hints.actions.remove
export const selectHintCategory = hints.actions.selectCategory
export const showHint = hints.actions.show
export const hideHint = hints.actions.hide
export const markHintAsViewed = hints.actions.markHintAsViewed
export const setSkipObligatoryHints = hints.actions.setSkipObligatoryHints
